import { ErrorEvent, EventHint } from '@sentry/core';
import { ApiError } from '../api';

const deleteMultipleErrorPropertiesDeep = (
  obj: ErrorEvent | Record<string, unknown>,
  propertyNames: string[],
): void => {
  const process = (
    current: Record<string, unknown>,
    visited = new Set<object>(),
  ): void => {
    if (!current || typeof current !== 'object' || visited.has(current)) return;
    visited.add(current);

    propertyNames.forEach(
      (prop) =>
        Object.prototype.hasOwnProperty.call(current, prop) &&
        delete current[prop],
    );

    Object.values(current)
      .filter(
        (value): value is Record<string, unknown> =>
          value !== null && typeof value === 'object',
      )
      .forEach((value) => process(value, visited));
  };

  process(obj as Record<string, unknown>);
};

export const filterSentryEvents = (event: ErrorEvent, hint: EventHint) => {
  const { originalException: error } = hint;

  if (error instanceof ApiError) {
    if (error.status < 500 || error.data?.error === 'invalid_grant') {
      return null;
    }
  }

  deleteMultipleErrorPropertiesDeep(event, [
    'password',
    'currentPassword',
    'newPassword',
    'newPasswordConfirmation',
  ]);

  return event;
};
